<template>
	<section :class="[
		'block-wrapper', 
		componentClass, 
		colorMode, 
		styleClasses,
		{
			visible: visible, 
			ready: ready
		}
	]">
		<div class="row">
			<div class="columns small-12">
				<div class="row align-middle">
					<div ref="textColumn" :class="textColumns" 
						:style="{ 
							order: textOrder,
						}">
						<wysiwyg-content ref="textWrapper" 
							:data="data.wysiwyg_content" 
							:columns="2"></wysiwyg-content>
					</div>
					<div :class="mediaColumns" :style="{ order: mediaOrder}">
						<media-content 
							ref="mediaWrapper" 
							:data="data.media_content" 
							:ready="ready" 
							:visible="visible"></media-content>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>


<script>
import BaseBlock from './Base'
import WysiwygContent from './wysiwyg/Content'
import MediaContent from './media/Content'

export default {
	extends: BaseBlock,
	data() {
		return {
			textOrder: 1,
			mediaOrder: 2,
			defaultColorMode: 'light',
			mobileBreakpoint: 640,
			componentClass: 'text-wrapper text-and-media-wrapper',
			content() {
				if (this.type==='textbox') return this.textbox;
			}
		}
	},
	computed: {
		mediaColumns() {
			return 'media-column columns small-12 medium-5 large-4 large-offset-1';
		},
		textColumns() {
			return 'text-column columns small-12 medium-7 large-5 large-offset-1';
		},
		styleClasses() {
			return this.data.styles || ''
		},
		backgroundColorClasses() {
			return this.data.bgcolors || ''
		}
	},
	methods: {
		adjustForWidthChange() {
			this.setFlexOrders()
		},
		setFlexOrders() {
			this.textOrder = ((window.innerWidth<=this.mobileBreakpoint) || ((window.innerWidth>=this.mobileBreakpoint) && (this.data.media_location!=='left'))) ? 1 : 2;
			this.mediaOrder = ((window.innerWidth<=this.mobileBreakpoint) || ((window.innerWidth>=this.mobileBreakpoint) && (this.data.media_location!=='left'))) ? 2 : 1;
		},
		scrollNow() {
			this.$scrollTo('component-2', 700);
		}
	},
	mounted() {
		this.adjustForWidthChange()
		if (this.data.theme.length>0) {
			this.defaultColorMode = this.data.theme
		}
		window.addEventListener('resize', this.adjustForWidthChange)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.adjustForWidthChange)
	},
	components: {
		WysiwygContent,
		MediaContent
	}
}
</script>

<style lang="scss">
	@import "../../styles/scss/global/block-wrapper";
	@import "../../styles/scss/component/text";
	@import "../../styles/scss/component/text-and-media";
</style>